import React from "react";
import { Text, TextInput, View } from "react-native";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";

type StreamDescriptionProps = {
  title?: string;
  placeholder?: string;
  numberOfLines?: number;
  description?: string;
  setDescription?: (text: string) => void;
  editable?: boolean;
};

const StreamDescription: React.FC<StreamDescriptionProps> = ({
  title,
  placeholder = "",
  numberOfLines = 5,
  description = "",
  setDescription,
  editable = true,
}) => {
  return (
    <>
      <Text
        style={[
          AppFontStyle.REGULAR_ANYBODY_12,
          { color: AppColors.gray_C3C3C3 },
        ]}
      >
        {title}
      </Text>
      <TextInput
        style={[
          AppFontStyle.REGULAR_ANYBODY_12,
          {
            backgroundColor: AppColors.gray_1B1B1B,
            borderRadius: 10,
            paddingHorizontal: 7,
            paddingVertical: 15,
            marginTop: 10,
          },
        ]}
        multiline={true}
        numberOfLines={numberOfLines}
        placeholderTextColor={AppColors.gray_C3C3C3}
        placeholder={placeholder}
        value={description}
        editable={editable}
        onChangeText={(text) => setDescription(text)}
      />
    </>
  );
};

export default StreamDescription;
